<template>
  <div v-loading.fullscreen="loading">
    <div v-if="!loading">
      <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'fieldManagerList' }"> {{$t('entities.fieldManager.plural')}} </el-breadcrumb-item>
        <el-breadcrumb-item v-if="editing && model" :to="{ name: 'fieldManagerShow', params: { id: model.id } }">{{ model.name }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="editing">{{$t('table.edit')}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="!editing">{{$t('table.add')}}</el-breadcrumb-item>
      </el-breadcrumb>

      <h2 class="page-title"> {{ editing ? $t('table.edit') + ' ' + $t('entities.fieldManager.singular') : $t('table.add') + ' ' + $t('entities.fieldManager.singular') }}</h2>


      <el-form
        ref="form"
        :model="model"
        :label-position="labelPosition"
        :label-width="labelWidth"
        :rules="rules"
        @submit.native.prevent="save"
      >
        <div class="block">
        <el-form-item label="Name" prop="name">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              v-model="model.name"
            ref="focus"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="LastName" prop="lastName">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              v-model="model.lastName"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="Email" prop="email">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              v-model="model.email"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="Phone" prop="phone">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              v-model="model.phone"
            />
          </el-col>
        </el-form-item>

        </div>

        <div class="button-group mt-3">
          <el-button
            @click="save()"
            :disabled="loading"
            type="primary"
            icon="el-icon-fa-floppy-o"
          >
            Save
          </el-button>
          <el-button
            @click="back()"
            :disabled="loading"
            icon="el-icon-fa-times"
          >
            Cancel
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import validators from '@/shared/form/validators';

export default {
  name: 'app-fieldManager-form',

  props: {
    id: String,
    previous: String,
  },

  data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: false
        }),
        lastName: validators.string({
          label: 'LastName',
          required: false
        }),
        email: validators.string({
          label: 'Email',
          required: true,
        }),
        phone: validators.string({
          label: 'Phone',
          required: false,
        }),
        club: validators.hasOne({
          label: 'Club',
          required: false,
        }),
      },
    };
  },

  created() {
    this.$store.dispatch('entities/fieldManager/loadOptions');

    if (this.id) {
      this.$store
        .dispatch('entities/fieldManager/edit', this.id)
        .catch(() =>
          this.$router.push({ name: 'fieldManagerList' }),
        );
    } else {
      this.$store.dispatch('entities/fieldManager/new');
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/fieldManager/clear');
    next();
  },

  computed: {
    ...mapGetters({
      model: 'entities/fieldManager/model',
      loading: 'entities/fieldManager/loading',
      labelPosition: "shared/labelPosition",
      labelWidth: "shared/labelWidth",

      options: 'entities/fieldManager/options',
    }),

    editing: state => !!state.id,
  },

  methods: {
    save() {
      this.$refs.form.validate().then(valid => {
        if (!valid) {
          return;
        }

        this.$store
          .dispatch('entities/fieldManager/save')
          .then(() => {
            this.back();
          });
      });
    },

    back() {
      if (this.previous === 'show') {
        this.$router.push({
          name: 'fieldManagerShow',
          params: { id: this.id },
        });
        return;
      }

      this.$router.push({ name: 'fieldManagerList' });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/field-manager/field-manager-form.vue?7c9d7044